
import { ArticleData } from "./types";

export const endEndDesign: ArticleData = {
  id: 3,
  slug: "recommendation-systems",
  title: "Framework for Recommendation System problems",
  author: "Bharathi Thangamani",
  publishDate: "May 1, 2023",
  lastUpdated: "May 8, 2025",
  category: "ML System Design",
  readTime: "12 min read",
  readCount: 20,
  likeCount: 2,
  isPremium: true,
  contentType: "markdown",
  description: "A system design template for tackling ML system design recommender systems qns.",
  tags: ["machine learning", "content moderation", "system design"],
  contentPath: "/docs/e2edesign.md" 
};
